interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "HTG";
};

const HTG: Currency = Object.freeze({
  "displayName": "Haitian Gourde",
  "numericCode": 332,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "HTG",
  "symbol": "G"
});

export { HTG };
